// extracted by mini-css-extract-plugin
export default {"thresholdContainer":"booking_thresholds-module___thresholdContainer___d4489f23"};